const updates = [
  { date: '2026-07-30', title: '妖精视频本周热门精选合集更新上线', tag: '热门推荐' },
  { date: '2026-07-29', title: '桃花视频全新影视大全专题页面发布', tag: '平台更新' },
  { date: '2026-07-28', title: '苹果视频+榴莲视频双平台资源同步完成', tag: '资源同步' },
  { date: '2026-07-27', title: '豆花视频经典回顾精选系列新增50+部', tag: '内容新增' },
  { date: '2026-07-26', title: '菠萝视频最新热门视频推荐榜单发布', tag: '榜单更新' },
  { date: '2026-07-25', title: '红杏视频专区内容索引全面升级优化', tag: '功能优化' },
  { date: '2026-07-24', title: '影视大全板块新增智能分类筛选功能', tag: '新功能' },
  { date: '2026-07-23', title: '热门视频合集周榜TOP100排名更新', tag: '周榜' },
  { date: '2026-07-22', title: '青青草视频三月运营报告：覆盖平台突破50+', tag: '运营报告' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">最新动态</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              青青草视频·热门视频合集运营动态与平台更新速览
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
            <div className="space-y-5">
              {updates.map((item, i) => (
                <div key={i} className="relative flex items-start gap-5 pl-0">
                  <div className="relative z-10 w-[39px] h-[39px] rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 shadow-md shadow-primary-500/20">
                    <span className="text-background-50 text-xs font-bold">{i + 1}</span>
                  </div>
                  <div className="flex-1 min-w-0 pt-1.5">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="mt-1.5 text-sm font-semibold text-foreground-900 leading-snug">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}